export const SHOW = 'consigaz_web/loading/SHOW'
export const DISMISS = 'consigaz_web/loading/DISMISS'